export default {
  iconBaseUrl: '//i.cdn-surfline.com/buoyweather/images/direction_icons/',
  weatherIconPath: 'https://wa.cdn-surfline.com/quiver/0.18.2/weathericons',
  lunarIconPath: 'https://wa.cdn-surfline.com/quiver/0.18.2/moonphaseicons',
  cookieDomain: '.buoyweather.com',
  favoritesManagerUrl: '/user/settings/favorites',
  links: {
    header: {
      support: '/info.jsp?id=21736',
    },
    appUpsell: {
      apple: 'https://itunes.apple.com/us/app/buoyweather-accurate-marine-weather-forecasts/id686664992?mt=8',
    },
    paywall: {
      upgrade: 'https://www.buoyweather.com/upgrade',
    },
    print: {
      written: (lat, lon) => `/forecast/marine-weather/print/written/@${lat},${lon}`,
      charts: (lat, lon) => `/forecast/marine-weather/print/charts/@${lat},${lon}`,
    },
    learnMore: '//www.buoyweather.com/news/news/buoyweather-now-offers-multiple-forecast-models/',
    support: 'mailto:support@buoyweather.com',
    charts: '/map',
  },
  pages: {
    error: {
      support_email: 'support@buoyweather.com',
    },
    forecast: {
      marine_weather: {
        pointOfInterest: poi =>
          `/forecast/marine-weather/spot/${poi.title.replace(/[^a-z0-9]+/gi, '+')}/@${poi.location.coordinates[1]},${poi.location.coordinates[0]}`,
        getUrl: (lat, lon) => `/forecast/marine-weather/@${lat},${lon}`,
        paywall: {
          wind_wave_tide: {
            free_days: 2,
          },
        },
        tideScale: {
          four: [3, 2, 1, 0, -1, -2, -3],
          six: [4, 2, 0, -2, -4],
          eight: [6, 4, 2, 0, -2, -4, -6],
          twelve: [9, 6, 3, 0, -3, -6, -9],
          sixteen: [12, 8, 4, 0, -4, -8, -12],
          twenty: [15, 10, 5, 0, -5, -10, -15],
          thirtytwo: [24, 16, 8, 0, -8, -16, -24],
        },
      },
    },
  },
};



// WEBPACK FOOTER //
// ./src/config/base.js